module.exports = __webpack_public_path__ + "img/coca-cola-logo.ecaf9130.png";